import { InternalAxiosRequestConfig } from 'axios';
import { BUILD_VERSION } from 'shared/app/constants';

function createId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return `${Math.random().toString(36).substring(2, 9)}`;
}

// it's constant while the app is running, and different after app restarts
export const sessionId = `${createId()}-${createId()}-${createId()}-${BUILD_VERSION}`;

/**
 * Intercepts all HTTP calls via axios and adds a session-id header.
 */
export const sessionAxiosInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers = config.headers ?? {};
  config.headers['session-id'] = `${sessionId}`;
  return config;
};
